import { useCallback } from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import warn from '@zenbusiness/application-commons-utils/warn';

import CheckoutCard from '../CheckoutCard';
import EditView from './EditView';
import { SECTION_KEYS } from '../../constants/sections';

const MESSAGE_IDS = {
  title: 'shopping.page.checkoutSmartLlc.paymentInfoCard.title'
};

function PaymentInfoCard({ hideEdit, onProcessOrder, onValidateOrderForm, sectionNumber }) {
  const sectionKey = SECTION_KEYS.PAYMENT_INFO;

  const handlePlaceOrder = useCallback(
    async (paymentData) => {
      try {
        await onValidateOrderForm();
        onProcessOrder(paymentData);
      } catch (errors) {
        // Validation failed, errors already handled in validateOrderForm
        warn('Order cannot be placed due to validation errors');
      }
    },
    [onProcessOrder, onValidateOrderForm]
  );

  return (
    <CheckoutCard
      alwaysEdit
      hideEdit={hideEdit}
      sectionKey={sectionKey}
      sectionNumber={sectionNumber}
      title={<FormattedMessage id={MESSAGE_IDS.title} />}
    >
      <CheckoutCard.Edit>
        <EditView onPlaceOrder={handlePlaceOrder} />
      </CheckoutCard.Edit>
    </CheckoutCard>
  );
}

PaymentInfoCard.propTypes = {
  hideEdit: PropTypes.bool,
  onProcessOrder: PropTypes.func,
  onValidateOrderForm: PropTypes.func,
  sectionNumber: PropTypes.number.isRequired
};

export default PaymentInfoCard;
